module.exports = __webpack_public_path__ + "static/media/opening_03.8498f6af.webp";